import { Form, Input } from 'antd';
import DynamicForm from '@/components/Web/DynamicForm';
import GrtWebButton from '@/components/Web/GrtButton';
import { Display } from '@/components/Display/Display';
import { useState, useEffect } from 'react';
import { Hide } from '@/components/Hide';
import s from './style.module.scss';

const WebDynamicForm = (props) => {
    const [errorMsg, setErrorMsg] = useState('');
    const [activeTab, setActiveTab] = useState('1');
    const { hasClarification, need_topic, need_profile, topic_value, data = [], onSubmit } = props;
    const [formInstance] = Form.useForm();

    const handleSave = () => {
        formInstance
            .validateFields()
            .then(async (res) => {
                console.log(res, 'res');
                setErrorMsg('');
                onSubmit(res);
            })
            .catch((err) => {
                if (need_profile && need_topic) {
                    setErrorMsg('请填写必要信息');
                }

                console.log(err, 'err');
            });
    };
    useEffect(() => {
        if (data && data.length && formInstance) {
            let obj = {};
            data.forEach((item) => {
                obj[item.en_name] = item.value;
            });
            formInstance.setFieldsValue({
                ...obj,
                topic_value: topic_value || ''
            });
        }
    }, [data, formInstance, topic_value]);
    const initTab = () => {
        if (need_profile) {
            setActiveTab('1');
            return false;
        }
        if (need_topic) {
            setActiveTab('2');
        } else {
            setActiveTab('1');
        }
    };
    useEffect(() => {
        initTab();
    }, [need_topic, need_profile]);
    return (
        <>
            <div className={s['tab-wrap']}>
                <Display show={need_profile}>
                    <div data-active={activeTab === '1'} className={s['tab-item']} onClick={() => setActiveTab('1')}>
                        个人信息
                    </div>
                </Display>

                <Display show={need_topic}>
                    <div data-active={activeTab === '2'} className={s['tab-item']} onClick={() => setActiveTab('2')}>
                        学习目标
                    </div>
                </Display>
            </div>
            <Form layout="horizontal" form={formInstance} disabled={hasClarification} className={s['dynamic-form-wrap']}>
                <Hide show={activeTab === '1'}>
                    <Display show={need_profile}>
                        <div className={s['form-tip-text']}>
                            填写后推荐更精准，填写结果仅用于推荐学习内容，不影响平台个人信息。如需修改，对我说 "帮我修改画像"。
                        </div>
                        {data && data.map((item, index) => <DynamicForm key={index} formInstance={formInstance} {...item} />)}
                    </Display>
                </Hide>
                <Hide show={activeTab === '2'}>
                    <Display show={need_topic}>
                        <Form.Item
                            className={s['form-topic-item']}
                            layout="vertical"
                            name="topic_value"
                            rules={[{ required: true, message: '请描述你想要学习的主题' }]}
                            label="请描述你想要学习的主题"
                        >
                            <Input.TextArea rows={4} style={{ resize: 'none' }} />
                        </Form.Item>
                    </Display>
                </Hide>
            </Form>
            <Display show={!hasClarification}>
                <div className={s['btn-wrap']}>
                    <span className={s['error-msg']}>{errorMsg}</span>
                    <GrtWebButton size="small" type="primary" onClick={handleSave}>
                        确定
                    </GrtWebButton>
                </div>
            </Display>
        </>
    );
};
export default WebDynamicForm;
